// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationImageBlockEditPage_wrapper__Gzu0z"};